export class MenuCheckedModel {
    MenuID: number;
    Checked: boolean;
    Description: string;

    constructor(MenuID: number, Checked: boolean, Description: string) {
        this.MenuID = MenuID;
        this.Checked = Checked;
        this.Description = Description;
    }
}
